import vueProduct from "//www.qualityfood.ae/cdn/shop/t/102/assets/vue-product.js?v=42001233373008903131790139688";
import vueSidebar from "//www.qualityfood.ae/cdn/shop/t/102/assets/vue-sidebar.js?v=104748130373489148481790139688";


Vue.component('paginate', VuejsPaginate)

const collection_app = new Vue({
  el: "[data-behavior='vue']",
  components: {
    vueProduct,
    MugenScroll,
    vueSidebar
  },
  data: {
    data: [],
    busy: false,
    store: window.store,
    query_params: window.queryParams
  },
  beforeMount() {
    this.getProducts();
  },
  methods: {
    
    scrollToTop: function() {
      $('html, body').animate({
        scrollTop: $("#MainContent").offset().top - 200
      }, 500);
    },
    
	// Get All Products whithin collection
    
    
    getProducts() {
      let vm = this,
          params, 
          ajaxUrl = vm.store.url;
      
      vm.store.loading = true;
     
	  // Check URL params and apply them for ajax request.
      // Conver JSON Query to String Query      
      vm.checkParams();
      params = $.param(vm.query_params)
      console.log(ajaxUrl);
      $.ajax({
        url: ajaxUrl + params,
        type: 'GET',
        dataType: 'jsonp',
        error: function(xhr, status, error) {
//           alert('Error: ' +  error + ' | Status: ' + status);
          alert('There was an error trying to load the products. We are working on it. I the mean time we will redirect you to basic version.');
          window.location.href = window.location.href + '?view=alternate'
        },
        success: function(results) {
          console.log(results);

          
          vm.store.facets = results.facets;
          vm.store.products = results.items;
          vm.store.results = results;
          vm.store.loading = false;
          vm.store.first_load = true;
          vm.store.pagination = vm.makePagination(results)
        }
      });
      
    },

    checkParams() {
      let vm = this,
          searchParams = vm.store.searchParams;

      // Check if Product Type is available in param
      if (searchParams.has('product_type') == true) {
        let product_type = searchParams.get('product_type');
        vm.query_params.rb_product_type = product_type;
        vm.query_params['restrictBy[product_type]'] = product_type;
      } else {
        //         delete vm.query_params.rb_product_type;
        //         delete vm.query_params['restrictBy[product_type]'];
      }

      // Check if Vendor is available in param
      if (searchParams.has('vendor') == true) {
        let vendor = searchParams.get('vendor');
        vm.query_params['restrictBy[vendor]'] = vendor;
      } else {
        //         delete vm.query_params['restrictBy[vendor]'];
      }

      // Check if Tags are available in params
      if (searchParams.has('tags') == true) {
        let tags = searchParams.get('tags');
        vm.query_params['restrictBy[tags]'] = tags;
      } else {
        //         delete vm.query_params['restrictBy[tags]'];
      }

      // Check if Price is available in param
      if (searchParams.has('price') == true) {
        let price = searchParams.get('price');
        vm.query_params.rb_price = price;
        vm.query_params['restrictBy[price]'] = price;
      } else {
        //         delete vm.query_params.rb_price;
        //         delete vm.query_params['restrictBy[price]'];
      }

      // Check if Page is available in param
      if (searchParams.has('page') == true) {
        let page = searchParams.get('page');
        console.log('PAGE::: ');
        console.log(page);
        vm.paginate(page);
        //         vm.query_params.page = page;
        //         vm.query_params.startIndex = (page - 1) * 50;
      } 

      if (searchParams.has('sort_by') == true) {
        let sort = searchParams.get('sort_by');
        vm.query_params.sortBy = sort
      }

      if (searchParams.has('sort_order') == true) {
        let sortOrder = searchParams.get('sort_order');
        vm.query_params.sortOrder = sortOrder;
      }



    },
    
    openFilter() {
      this.store.filterOpen = true;
    },
    closeFilter() {
      this.store.filterOpen = false;
    },

    // Paginate
    paginate: function(pageNum) {
      let vm = this,
          searchParams = vm.store.searchParams;
      searchParams.set('page', pageNum);
      vm.query_params.page = pageNum;
      vm.query_params.startIndex = (pageNum - 1) * 50;
      var newPath = window.location.pathname + '?' + searchParams;
      window.history.replaceState({}, '', newPath);
      $("html, body").animate({ scrollTop: 0 }, "slow");
    },
    makePagination: function(data){
      var vm = this;

      var current_item_count = data.currentItemCount;
      var itemsPerPage = data.itemsPerPage;
      var startIndex = data.startIndex;
      var totalItems = data.totalItems;
      var pageNum = Math.ceil(totalItems / itemsPerPage);

      var pagination = {
        page: 1,
        page_count: pageNum,
        total_items: totalItems,
        start_index: startIndex,
        items_per_page: itemsPerPage,
        current_item_count: current_item_count
      }
      
      return pagination
//       console.log(pagination);
//       vm.$set(vm, 'store.pagination', pagination)
    },

  },
  
    watch: {
    // Watch the query for any change and update product listings
    query_params: {
      handler(val, oldVal) {
        console.log(val);
        this.getProducts();
      },
      deep: true
    },
    "store.search": function(val, oldVal) {
      let vm =this,
          searchParams = vm.store.searchParams;
      
        vm.query_params.q = val;
        searchParams.set('q', val)
        console.log(val);
        var newPath = window.location.pathname + '?' + searchParams;
        window.history.replaceState({}, '', newPath);
    },
    "store.filterOpen": function(val, oldVal) {
    	console.log(val);
      if (val == true) {
      	$('body').addClass('active-sidebar');
      } else {
        $('body').removeClass('active-sidebar');
      }
    },
    // Dropdown Sorting
    "store.sortBy": function(val, oldVal) {
      let vm = this,
          searchParams = vm.store.searchParams;
      
      if (val == 'relevance') {
        vm.query_params.sortBy = 'relevance';
        searchParams.set('sort_by', 'relevance')
      } else if (val == 'sales_amount') {
        vm.query_params.sortBy = 'sales_amount';	
        vm.query_params.sortOrder = 'desc';
        searchParams.set('sort_by', 'sales_amount')
      } else if ( val == 'title_az' ) {
        vm.query_params.sortBy = 'title';	
        vm.query_params.sortOrder = 'asc';
		searchParams.set('sort_by', 'title')
        searchParams.set('sort_order', 'asc')
      } else if ( val == 'title_za' ) {
        vm.query_params.sortBy = 'title';	
        vm.query_params.sortOrder = 'desc';
        searchParams.set('sort_by', 'title')
        searchParams.set('sort_order', 'desc')
      } else if ( val == 'price_lth' ) {
        vm.query_params.sortBy = 'price';	
        vm.query_params.sortOrder = 'asc';
        searchParams.set('sort_by', 'price')
        searchParams.set('sort_order', 'asc')
      } else if ( val == 'price_htl' ) {
        vm.query_params.sortBy = 'price';	
        vm.query_params.sortOrder = 'desc';
        searchParams.set('sort_by', 'price')
        searchParams.set('sort_order', 'desc')
      } 
      
//       else if ( val == 'reviews_average_score_lth' ) {
//         vm.query_params.sortBy = 'reviews_average_score';	
//         vm.query_params.sortOrder = 'asc';
//       } else if ( val == 'reviews_average_score_htl' ) { 
//         vm.query_params.sortBy = 'reviews_average_score';	
//         vm.query_params.sortOrder = 'desc';
//       } else if ( val == 'total_reviews_lth' ) { 
//         vm.query_params.sortBy = 'total_reviews';	
//         vm.query_params.sortOrder = 'asc';
//       } else if ( val == 'total_reviews_htl' ) {
//         vm.query_params.sortBy = 'total_reviews';	
//         vm.query_params.sortOrder = 'desc';
//       }
      
      
      var newPath = window.location.pathname + '?' + searchParams;
      window.history.replaceState({}, '', newPath);
    }
  },
});
